export { default } from './CarRentalContainerMobile';
